import { FormControl } from '@angular/forms';
import { JawSelectionEnums } from '@shared/enums/jaw.enum';
import { filter, map, merge } from 'rxjs';

const mapJawSelection = ({ isUpperChecked, isLowerChecked }: { isUpperChecked: boolean; isLowerChecked: boolean }) => {
	if (isLowerChecked && isUpperChecked) {
		return JawSelectionEnums.Both;
	}
	if (isLowerChecked) {
		return JawSelectionEnums.Lower;
	}
	if (isUpperChecked) {
		return JawSelectionEnums.Upper;
	}

	return JawSelectionEnums.None;
};

export const observeJawSelection = (upperControl: FormControl<boolean>, lowerControl: FormControl<boolean>) =>
	merge(
		upperControl.valueChanges.pipe(
			filter(() => !upperControl.disabled),
			map(isUpperChecked => mapJawSelection({ isLowerChecked: lowerControl.value, isUpperChecked }))
		),
		lowerControl.valueChanges.pipe(
			filter(() => !lowerControl.disabled),
			map(isLowerChecked => mapJawSelection({ isLowerChecked, isUpperChecked: upperControl.value }))
		)
	);
